import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { FormField } from '../../../../../utils/FormFields';

const InvestmentProfileTab = ({
  account, changedAccount, showChanges,
}) => {
  const editInvestExp = changedAccount.InvestExperience;
  const compareInvestExp = [];
  editInvestExp.map((exp) => {
    account.InvestExperience.map((i) => {
      if (parseInt(i.InvestExperienceId, 10) === parseInt(exp.InvestExperienceId, 10)) {
        compareInvestExp.push(i);
      }
      return {};
    });
    return {};
  });
  return (
    <Form>
      <Label style={{ fontWeight: 500, fontSize: '20px', display: 'block' }}>
        {showChanges ? 'New changes' : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {editInvestExp.map((inv, i) => (
              <React.Fragment>
                <FormToShow investExp={inv} refInv={compareInvestExp[i]} />
                <br />
              </React.Fragment>
            ))}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareInvestExp.map((inv) => (
              <React.Fragment>
                <FormToShow investExp={inv} />
                <br />
              </React.Fragment>
            ))}
          </FormGroup>
        )}
    </Form>
  );
};

InvestmentProfileTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default InvestmentProfileTab;

const FormToShow = ({ investExp, refInv }) => (
  <React.Fragment>
    <FormField
      name="InvestExperienceId"
      value={investExp.InvestExperienceId}
      label="Id"
    />
    <FormField
      name="InvestExperienceDescription"
      value={investExp.InvestExperienceDescription}
      label="Description"
    />
    <FormField
      name="InvestExperienceE"
      value={investExp.InvestExperienceE}
      label="Experience"
      changedColor={refInv && refInv.InvestExperienceE !== investExp.InvestExperienceE}
    />
    <FormField
      name="InvestExperienceQ"
      value={investExp.InvestExperienceQ}
      label="Quantity"
      changedColor={refInv && refInv.InvestExperienceQ !== investExp.InvestExperienceQ}
      dataTypeDecimalName="quantity"
    />
    <FormField
      name="InvestExperienceM"
      value={investExp.InvestExperienceM}
      label="Amount"
      changedColor={refInv && refInv.InvestExperienceM !== investExp.InvestExperienceM}
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  investExp: PropTypes.object.isRequired,
  refInv: PropTypes.object,
};

FormToShow.defaultProps = {
  refInv: undefined,
};
